
import { useEffect, useState } from 'react';
import useNewItemChange from '../../../../../../../../../EHR/EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';
import NotificationHandler from '../../../../../../../../../../utils/NotificationHandler';
import { enumUtil } from '../../../../../../../../../../utils/Enum';
import ShowItemContent from './ShowItemContent';

const File = ({ item, setItem, activeAccordion, validations, isGroupNote, ...props }) => {
    const { handleFileChange,
        // handleRemoveFile 
    } = useNewItemChange(setItem, 'Viewer', activeAccordion);

    // defining in local context to set file/ answer to "" on handleFileRemove

    const handleRemoveFile = (item) => {
        // if (userIs === 'Viewer') {
        setItem(prev =>
            prev.map(section =>
                section.key === activeAccordion
                    ? {
                        ...section,
                        items: section.items.map(currItem =>
                            currItem.ItemID === item.ItemID
                                ? { ...currItem, answer: '', file: '' }
                                : currItem
                        )
                    }
                    : section
            )
        );
        // }
    };

    const [imagePreview, setFilePreview] = useState('');
    const [dragActive, setDragActive] = useState(false);

    useEffect(() => {
        if (item.file) {
            setFilePreview(item.file)
        } else {
            setFilePreview('');
        }
    }, [item.file])

    const handleDragOver = (e) => {
        e.preventDefault();
        setDragActive(true);
    };

    const handleDragLeave = () => {
        setDragActive(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        setDragActive(false);
        if (!file) return; // Ensure a file is dropped

        if (!file.type.startsWith("image/")
            //  && file.type !== "application/pdf"
        ) { // || file.type === "image/svg+xml"
            NotificationHandler('Only images are allowed.', enumUtil.enumtoaster.error)
            return;
        }
        // Check if the dropped file is an image
        let asEvent = { target: { files: [file] } };
        handleFileChange(asEvent, item);
    };;


    return (
        <div className="d-flex gap-10">
            <div className="ar-form-counter flex-center">
                <p className='text text-black'>{props?.itemCount}</p>
            </div>
            <div className='content-box d-flex flex-column gap-6'>
                <p className={`heading fs-13 d-flex gap-01 ${validations?.isInvalid ? 'Denied-clr' : ''}`}>
                    {/* {item.content || '[Enter prompt or question]'} */}
                    {ShowItemContent(item, isGroupNote)}
                    {/* \\ Required icon commented \\ */}
                    {/* {[true, "true"].includes(item?.isRequired) ? <span className="text font-m Denied-clr fs-14">*</span> : <></>} */}
                </p>
                <div className={`input w-100 ${validations?.isInvalid ? 'error' : ''}`}>
                    {item?.answer ?
                        (<div className='d-flex align-items-center justify-content-between form-control'>
                            <p className='text singleLine-ellispis w-100'>{item?.answer}</p>
                            <i className='icon-x-cros fs-14 dark-clr' onClick={() => handleRemoveFile(item)}></i>
                        </div>)
                        :
                        (<div className={`upload-file form-control align-items-center h-100 d-flex align-items-center p-0 ${dragActive ? 'opacity-50' : ''}`}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                        >
                            <input
                                type="file"
                                id={`PatientFile-${item.ItemID}`}
                                name={`PatientFile-${item.ItemID}`}
                                onChange={e => handleFileChange(e, item)}
                                accept=".png,.jpg,.jpeg"
                                multiple={false} // Ensures only one file
                            />

                            <label className="w-100 d-block px-2" htmlFor={`PatientFile-${item.ItemID}`}>
                                <p className='f-11 ar-light-color text fst-normal' htmlFor={`PatientFile-${item.ItemID}`}>Upload your picture</p>
                            </label>
                        </div>)
                    }
                </div>
            </div>
        </div>
    )

}

export default File;